(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-draws/assets/javascripts/api-calls/api-call.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-draws/assets/javascripts/api-calls/api-call.js');

'use strict';

const logger = svs.isServer ? require('@svenskaspelab/trinidad-core').core.logger('module:lyckoplatsen') : svs.lyckoplatsen.logger;
const productMapping = svs.isServer ? require('../../../../shared-constants/assets/javascripts/product-mapping.es6') : svs.lyckoplatsen.components.shared_constants.productMapping;
const drawgamesApiCaller = svs.isServer ? require('@svenskaspelab/trinidad-core').core.components.require('tur', 'api-caller').drawgamesApiCaller : svs.tur.apiCaller.drawgames;
async function fetchPrimaryDraw(req) {
  try {
    var _result$response;
    const result = await drawgamesApiCaller.getDrawProductDraws({
      product: productMapping.getProductDrawId(productMapping.CONSTANTS.LYCKOPLATSEN_PRIMARY),
      req
    });
    return (_result$response = result.response) !== null && _result$response !== void 0 ? _result$response : result;
  } catch (error) {
    logger.info("Failed to get primary draw", req);
    throw error;
  }
}
async function fetchPrimaryDrawByDrawNumber(drawNumber, req) {
  try {
    var _result$response2;
    const result = await drawgamesApiCaller.getDrawProductDrawsByDrawNumber({
      product: productMapping.getProductDrawId(productMapping.CONSTANTS.LYCKOPLATSEN_PRIMARY),
      drawNumber,
      req
    });
    return (_result$response2 = result.response) !== null && _result$response2 !== void 0 ? _result$response2 : result;
  } catch (error) {
    logger.info("Failed to get primary draw by draw number", req);
    throw error;
  }
}
async function fetchSecondaryDraw(req) {
  try {
    var _result$response3;
    const result = await drawgamesApiCaller.getDrawProductDraws({
      product: productMapping.getProductDrawId(productMapping.CONSTANTS.LYCKOPLATSEN_SECONDARY),
      req
    });
    return (_result$response3 = result.response) !== null && _result$response3 !== void 0 ? _result$response3 : result;
  } catch (error) {
    logger.info("Failed to get secondary draw", req);
    throw error;
  }
}
async function fetchSecondaryDrawByDrawNumber(drawNumber, req) {
  try {
    var _result$response4;
    const result = await drawgamesApiCaller.getDrawProductDrawsByDrawNumber({
      product: productMapping.getProductDrawId(productMapping.CONSTANTS.LYCKOPLATSEN_SECONDARY),
      drawNumber,
      req
    });
    return (_result$response4 = result.response) !== null && _result$response4 !== void 0 ? _result$response4 : result;
  } catch (error) {
    logger.info("Failed to get secondary draw by draw number", req);
    throw error;
  }
}
if (svs.isServer) {
  module.exports = {
    fetchPrimaryDraw,
    fetchPrimaryDrawByDrawNumber,
    fetchSecondaryDraw,
    fetchSecondaryDrawByDrawNumber
  };
} else {
  Object.assign(svs.lyckoplatsen.components.shared_draws.api_calls, {
    fetchPrimaryDraw,
    fetchPrimaryDrawByDrawNumber,
    fetchSecondaryDraw,
    fetchSecondaryDrawByDrawNumber
  });
}

 })(window);